// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const Insuranceform = {
  "CLAIMS_MADE": "CLAIMS_MADE",
  "OCCURRENCE": "OCCURRENCE",
  "OCCUR": "OCCUR"
};

const Insurancetype = {
  "GL": "GL",
  "AU": "AU",
  "WC": "WC",
  "UMB": "UMB",
  "XL": "XL",
  "CY": "CY",
  "PL": "PL",
  "CUSTOM": "CUSTOM"
};

const Certificatestatus = {
  "APPROVED": "APPROVED",
  "PENDING": "PENDING",
  "EXPIRED": "EXPIRED",
  "REVIEW": "REVIEW",
  "REQUESTED": "REQUESTED",
  "NOT_APPROVED": "NOT_APPROVED",
  "INACTIVE": "INACTIVE",
  "MULTI_AGENT": "MULTI_AGENT"
};

const Projectstatus = {
  "ACTIVE": "ACTIVE",
  "INACTIVE": "INACTIVE",
  "ARCHIVED": "ARCHIVED"
};

const Vendorstatus = {
  "COMPLIANT": "COMPLIANT",
  "NOT_COMPLIANT": "NOT_COMPLIANT",
  "ARCHIVED": "ARCHIVED"
};

const Vendornotificationstatus = {
  "ACTIVE": "ACTIVE",
  "DISABLED": "DISABLED"
};

const Organizationtype = {
  "SYSTEM": "SYSTEM",
  "AGENCY": "AGENCY",
  "CLIENT": "CLIENT"
};

const Clientmode = {
  "PROJECT": "PROJECT",
  "HYBRID": "HYBRID"
};

const Userstatus = {
  "ACTIVE": "ACTIVE",
  "DISABLED": "DISABLED",
  "DELETED": "DELETED"
};

const Scanstatus = {
  "PENDING": "PENDING",
  "COMPLETED": "COMPLETED",
  "CANCELED": "CANCELED",
  "SUBMITTED": "SUBMITTED",
  "FAILED": "FAILED"
};

const Certificatetype = {
  "MULTI_AGENT": "MULTI_AGENT",
  "AGENT": "AGENT"
};

const Extractionmethod = {
  "OCR": "OCR",
  "CLAUDE": "CLAUDE",
  "HYBRID": "HYBRID",
  "MANUAL": "MANUAL"
};

const Extractionstrategy = {
  "CLAUDE_PRIMARY": "CLAUDE_PRIMARY",
  "OCR_PRIMARY": "OCR_PRIMARY",
  "PARALLEL": "PARALLEL",
  "HYBRID": "HYBRID"
};

const Anthropicmodel = {
  "CLAUDE_3_5_SONNET_20241022": "CLAUDE_3_5_SONNET_20241022",
  "CLAUDE_3_OPUS_20240229": "CLAUDE_3_OPUS_20240229",
  "CLAUDE_3_HAIKU_20240307": "CLAUDE_3_HAIKU_20240307",
  "CLAUDE_3_5_HAIKU_20241022": "CLAUDE_3_5_HAIKU_20241022"
};

const Scheduledemailstatus = {
  "PENDING": "PENDING",
  "PAUSED": "PAUSED",
  "CANCELLED": "CANCELLED",
  "SENT": "SENT",
  "FAILED": "FAILED"
};

const Activecertificatesndexname = {
  "BY_CLIEN_TSORT_UPDATEDAT": "byCLIENTsortUPDATEDAT",
  "BY_CLIEN_TSORT_CREAEDAT": "byCLIENTsortCREAEDAT",
  "BY_CLIEN_TSORT_FIRST_EXP": "byCLIENTsortFirstExp",
  "BY_CLIEN_TSORT_PRODUCER": "byCLIENTsortPRODUCER",
  "BY_CLIEN_TSORT_INSURED": "byCLIENTsortINSURED",
  "BY_CLIEN_TSORT_CERTIFICATEDATE": "byCLIENTsortCERTIFICATEDATE",
  "BY_CLIENT": "byCLIENT"
};

const Notificationtype = {
  "CERTIFICATE_SUBMISSION": "CERTIFICATE_SUBMISSION",
  "CERTIFICATE_SCAN_COMPLETE": "CERTIFICATE_SCAN_COMPLETE",
  "CERTIFICATE_EXPIRING": "CERTIFICATE_EXPIRING",
  "COMMENT_MENTION": "COMMENT_MENTION",
  "CERTIFICATE_APPROVED": "CERTIFICATE_APPROVED",
  "CERTIFICATE_REJECTED": "CERTIFICATE_REJECTED",
  "DOCUMENT_UPLOAD_RECEIVED": "DOCUMENT_UPLOAD_RECEIVED"
};

const Notificationstatus = {
  "UNREAD": "UNREAD",
  "READ": "READ",
  "ARCHIVED": "ARCHIVED"
};

const Filecabinetaction = {
  "ADD_TO_FOLDER": "ADD_TO_FOLDER",
  "REMOVE_FROM_FOLDER": "REMOVE_FROM_FOLDER",
  "CREATE_FOLDER": "CREATE_FOLDER",
  "DELETE_FOLDER": "DELETE_FOLDER",
  "RENAME_FOLDER": "RENAME_FOLDER",
  "MOVE_FOLDER": "MOVE_FOLDER",
  "MOVE_ITEM": "MOVE_ITEM"
};

const DocumentRequestType = {
  "CERTIFICATE": "CERTIFICATE",
  "OTHER": "OTHER"
};

const DocumentCategory = {
  "POLICY": "POLICY",
  "ENDORSEMENT": "ENDORSEMENT",
  "CONTRACT": "CONTRACT",
  "LEASE": "LEASE",
  "DRIVERS_LICENSE": "DRIVERS_LICENSE",
  "OTHER": "OTHER"
};

const DocumentRequestStatus = {
  "PENDING": "PENDING",
  "UPLOADED": "UPLOADED",
  "EXPIRED": "EXPIRED",
  "PARTIALLY_UPLOADED": "PARTIALLY_UPLOADED"
};

const DocumentUploadStatus = {
  "UPLOADED": "UPLOADED",
  "APPROVED": "APPROVED",
  "REJECTED": "REJECTED",
  "PENDING_REVIEW": "PENDING_REVIEW"
};

const { CERTIFICATE, CERTIFICATECOVERAGE, VENDORCOVERAGE, CLIENTCOVERAGE, PROJECT, PROJECTVENDORS, CLIENTVENDORS, INSURANCEAGENT, VENDOR, USER, CLIENT, ORGANIZATION, ANTHROPICSETTINGS, EMAILNOTIFICATIONS, SCHEDULEDEMAILS, ACORD25SCAN, ACORD25SCANCOVERAGE, ACTIVITY, NOTIFICATION, FILECABINETFOLDER, FILECABINETITEM, FILECABINETACTIVITY, DOCUMENTREQUEST, DOCUMENTUPLOAD, EXTRACTIONLOG, ModelCERTIFICATEConnection, DocumentCategoryRequest } = initSchema(schema);

export {
  CERTIFICATE,
  CERTIFICATECOVERAGE,
  VENDORCOVERAGE,
  CLIENTCOVERAGE,
  PROJECT,
  PROJECTVENDORS,
  CLIENTVENDORS,
  INSURANCEAGENT,
  VENDOR,
  USER,
  CLIENT,
  ORGANIZATION,
  ANTHROPICSETTINGS,
  EMAILNOTIFICATIONS,
  SCHEDULEDEMAILS,
  ACORD25SCAN,
  ACORD25SCANCOVERAGE,
  ACTIVITY,
  NOTIFICATION,
  FILECABINETFOLDER,
  FILECABINETITEM,
  FILECABINETACTIVITY,
  DOCUMENTREQUEST,
  DOCUMENTUPLOAD,
  EXTRACTIONLOG,
  Insuranceform,
  Insurancetype,
  Certificatestatus,
  Projectstatus,
  Vendorstatus,
  Vendornotificationstatus,
  Organizationtype,
  Clientmode,
  Userstatus,
  Scanstatus,
  Certificatetype,
  Extractionmethod,
  Extractionstrategy,
  Anthropicmodel,
  Scheduledemailstatus,
  Activecertificatesndexname,
  Notificationtype,
  Notificationstatus,
  Filecabinetaction,
  DocumentRequestType,
  DocumentCategory,
  DocumentRequestStatus,
  DocumentUploadStatus,
  ModelCERTIFICATEConnection,
  DocumentCategoryRequest
};